import React, { useEffect, useState, useRef, useCallback } from 'react';
import Multiselect from 'multiselect-react-dropdown';
import { useDispatch, useSelector } from "react-redux";
import {
    updateProjectSupportingDocs, destroyProjectSupportingDocs,
    documentApprovedByApprover, updateDocumentByOwner, sendUpdateDocumentRequestByOwners
} from '../../../../actions/supportingDocsActions'
import { useForm } from "react-hook-form";
import { Modal } from 'react-bootstrap';
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { useDropzone } from 'react-dropzone';
import DisapproveModal from '../ReusableComponent/DisapproveModal'
import UpdateModal from './UpdateModal';
import DataTablesSupportingDocs from './DataTablesSupportingDocs';
import moment from 'moment';

const SupportingDocs = (props) => {

    const dispatch = useDispatch();
    const { user } = useSelector(state => state.auth);
    const childRef = useRef();

    const [members, setMembers] = useState([]);
    const [files, setFiles] = useState([]);
    const [supportDocsId, setSupportDocsId] = useState()
    const [inputDocumentId, setInputDocumentId] = useState()
    const [inputDocumentTitle, setInputDocumentTitle] = useState()
    const [inputDocumentType, setInputDocumentType] = useState()
    const [inputSupportingDocsOwner, setInputSupportingDocsOwner] = useState([]);
    const [inputSupportingDocsApprover, setInputSupportingDocsApprover] = useState([]);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [inputProjectId, setInputProjectId] = useState("");
    const [deleteSupportingDocsModal, setDeleteSupportDocsModal] = useState(false)
    const [fileUploadeMode, setFileUploadeMode] = useState()

    const [selectedFileData, setSelectedFileData] = useState(false)
    const [editFileModal, setEditFileModal] = useState(false)

    const [inputProjectClientId, setInputProjectClientId] = useState("");
    const [inputProjectPartners, setInputProjectPartners] = useState([]);
    const [isCurrentOwner, setIsCurrentOwner] = useState(false);
    const [showRejectModal, setAddRejectModal] = useState(false);
    const [selectedRowData, setselectedRowData] = useState(false);
    const [rejectedReasonData, setRejectedReasonData] = useState([]);
    const [rejectedReasonVisible, setRejectedReasonVisible] = useState(false);
    const [isApproved, setIsApproved] = useState(false);
    const [isApprover, setIsApprover] = useState(false);
    const [isOwner, setIsOwner] = useState(false);
    const [isClientPartner, setIsIsClientPartner] = useState(false);
    const [isTextVisible, setIsTextVisible] = useState(true);
    const [isOwnerApproverDisable, setIsOwnerApproverDisable] = useState(false);
    const [isRejected, setIsRejected] = useState(false);

    const filesDropzon = files.map((file, i) => (
        <li key={file.path}>
            {file.path} - {file.size} bytes  <i onClick={() => removeSelectedFiles(file)} className="fa fa-trash"></i>
        </li>
    ));
   

    const validationSchema = yup.object().shape({
        isOwner: yup.boolean(),
        files: yup.array().nullable().when('isOwner', {
            is: true,
            then: yup.array().required("You need to provide a file").min(1, 'You need to provide a file')
        }).min(1, 'You need to provide a file'),
        documentType: yup.string().required('This filed is required'),
        documentTitle: yup.string().required('This filed is required'),
        supportingDocsOwner: yup.array(),
        supportingDocsApprover: yup.array(),
        isApproved: yup.boolean(),
    });

    const { register, handleSubmit, setValue, formState: { errors } } = useForm({
        mode: "onBlur",
        resolver: yupResolver(validationSchema),
    });
    
    const onDrop = useCallback(acceptedFiles => {
        setFiles([...acceptedFiles])
        setValue('files', acceptedFiles)
    }, [setValue])

    const { getRootProps, getInputProps } = useDropzone({ onDrop, multiple: fileUploadeMode });
    useEffect(() => {
        if (props?.data) {
            // console.log(props, 'supporting docs')
            setValue('documentType', props.documents?.upload_type)
            setValue('documentTitle', props.documents?.title)
            setValue('supportingDocsOwner', props.documents?.owner_members)
            setValue('supportingDocsApprover', props.documents?.approver_members)

            setInputDocumentId(props.documents?.id);
            setInputDocumentType(props.documents?.upload_type);
            setFileUploadeMode(props.documents?.upload_type === 'Multiple' ? true : false)
            setInputDocumentTitle(props.documents?.title);
            setSelectedFiles(props?.documents?.document_list);
            setInputSupportingDocsOwner(props.documents?.owner_members || [])
            setInputSupportingDocsApprover(props.documents?.approver_members || [])
            setRejectedReasonData(props?.documents?.document_rejection || [])
            setIsApproved(props?.documents?.is_approved)
            setIsRejected(props?.documents?.is_rejected)

            setMembers(props?.members || [])
            setInputProjectId(props.data?.id)
            setInputProjectClientId(props.data?.client_id)
            setInputProjectPartners(props?.data?.partners || [])
        }

    }, [props.data, props.members, props.documents, setValue]);

    useEffect(() => {
        if (inputSupportingDocsOwner || inputProjectPartners) {
            var isOwner;
            inputSupportingDocsOwner.find(function (value) {
                if (value.id === user.user_id) {
                    return isOwner = value;
                }
                return isOwner;
            });
            var isPartners
            inputProjectPartners?.find(function (value) {
                if (value.id === user.user_id) return isPartners = value;
                return isPartners;
            });
            var isApproverModule
            inputSupportingDocsApprover.find(function (value) {
                if (value.id === user.user_id) return isApproverModule = value;
                return isApproverModule;
            });

            if (inputProjectClientId === user.user_id) {
                setIsCurrentOwner(true)
                setIsApprover(false)
                setIsTextVisible(true)
                setIsOwnerApproverDisable(false)
                setIsIsClientPartner(true)
                setRejectedReasonVisible(true)
            }
            else if (isPartners) {
                setIsCurrentOwner(true)
                setIsApprover(false)
                setIsTextVisible(true)
                setIsOwnerApproverDisable(false)
                setIsIsClientPartner(true)
            }
            else if (isOwner && isApproverModule) {
                if (isApproved) setIsTextVisible(true);
                else setIsTextVisible(false);
                setIsApprover(true)
                setIsCurrentOwner(true)
                setIsOwnerApproverDisable(true)
                setValue('isOwner', true)
                setIsOwner(true)
                setRejectedReasonVisible(true)
            }
            else if (isOwner) {
                if (isApproved) setIsTextVisible(true);
                else setIsTextVisible(false);
                setIsCurrentOwner(true)
                setIsOwnerApproverDisable(true)
                setValue('isOwner', true)
                setIsOwner(true)
                setRejectedReasonVisible(true)
            }
            else if (isApproverModule) {
                setIsApprover(true)
                setIsTextVisible(true)
                setIsOwnerApproverDisable(true)
                setRejectedReasonVisible(true)
            }
            else {
                setIsCurrentOwner(false)
                setIsOwnerApproverDisable(true)
                setIsTextVisible(true)
            }
        }
    }, [inputSupportingDocsOwner, inputProjectPartners, user, inputSupportingDocsApprover, inputProjectClientId, isApproved, setValue])

    const onMemberSubmit = async (values, e) => {

        const formDataClientPartner = {
            project_id: inputProjectId,
            title: values.documentTitle,
            upload_type: values.documentType,
            owner_members: values.supportingDocsOwner,
            approver_members: values.supportingDocsApprover,
        }
        // Form for Owner 
        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append(`document`, files[i])
        }
        formData.append('project_id', inputProjectId)
        setFiles([])
        setValue('files' ,[] )
        console.log(values, ' Form values')
        if (isClientPartner) dispatch(updateProjectSupportingDocs(formDataClientPartner))
        else if (isOwner) dispatch(updateDocumentByOwner(formData))
        else return false;
    }

    const removeSelectedFiles = file => {
        const newFiles = [...files]
        newFiles.splice(newFiles.indexOf(file), 1)
        setFiles(newFiles)
        setValue('files', newFiles)
    };
    const handelChange = (e) => {
        setValue('supportingDocsOwner', e, { shouldValidate: true })
        setInputSupportingDocsOwner(e)
    }
    const handelChangeApprover = (e) => {
        setValue('supportingDocsApprover', e, { shouldValidate: true })
        setInputSupportingDocsApprover(e)
    }
    const deleteTimelineModalShow = data => {
        setSupportDocsId(data.id)
        setDeleteSupportDocsModal(true)
    }

    const deleteSupportingDocsModalClose = () => {
        setDeleteSupportDocsModal(false)
        setSupportDocsId()
    }
    const handleDeleteSupportingDocsSubmit = () => {
        dispatch(destroyProjectSupportingDocs(supportDocsId))
        setDeleteSupportDocsModal(false)
        setSupportDocsId()
    }
    const handleAddReasonClose = () => {
        setAddRejectModal(false);
        setselectedRowData(false);
    };
    const handleReasonShow = () => {
        setselectedRowData(inputProjectId);
        setAddRejectModal(true);
    };
    const handelRequestToEdit = () => {
        dispatch(sendUpdateDocumentRequestByOwners(inputDocumentId))
    };
    const handelObjectivesApproved = () => {
        dispatch(documentApprovedByApprover(inputDocumentId))
    };
    const handleEditModalClose = () => {
        setEditFileModal(false);
        setSelectedFileData(false);
    };
    const selectedData = (data) => {
        setSelectedFileData(data);
        setEditFileModal(true);
    };
    return (
        <>
            <form className="form-auth-small" onSubmit={handleSubmit(onMemberSubmit)} encType="multipart/form-data">
                <div className="row clearfix">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="card card-radius">
                            <div className="header card-header custum-bg-warning rounded">
                                <h2 className="text-white">Supporting Docs</h2>
                            </div>
                            <div className="body card-body-shadow">
                                {isOwner && !isTextVisible ?
                                    <div className="row">
                                        <div className="col-lg-12 col-md-6 col-sm-12">
                                            <div className="form-group">
                                                {/* <label htmlFor="job_number" className="control-label">Total Budget <span className='text-danger'>*</span></label> */}
                                                <div className="card">
                                                    <div className="body">
                                                        <section className="container">
                                                            <div {...getRootProps({ className: 'dropzone text-center' })}>
                                                                <input {...getInputProps()} />
                                                                <p>Drag and drop file or "Click" to browse</p>
                                                            </div>
                                                            <aside>
                                                                <h4>Files</h4>
                                                                <ul>{filesDropzon}</ul>
                                                            </aside>
                                                        </section>
                                                        {errors.files && (
                                                            <div className="text-danger pt-2">{errors.files.message}</div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    : null}
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="documentType" className="control-label">Document Title<span className='text-danger'>*</span></label>
                                            <input type="text" placeholder='Please Enter Document Title' className="form-control" defaultValue={inputDocumentTitle} onChange={(e) => setInputDocumentTitle(e.target.value)}
                                                {...register('documentTitle')} readOnly={isOwnerApproverDisable} />
                                            {errors.documentTitle && (<div className="text-danger pt-2">{errors.documentTitle.message}</div>)}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="documentType" className="control-label">Document Type<span className='text-danger'>*</span></label>
                                            <select disabled={isOwnerApproverDisable} defaultValue={inputDocumentType} name="documentType" id="documentType" className="form-control"
                                                onChange={(e) => setInputDocumentType(e.target.value)} {...register('documentType')}>
                                                <option value=''>Select</option>
                                                <option value='Single'>Single</option>
                                                <option value='Multiple'>Multiple</option>
                                            </select>
                                            {errors.documentType && (<div className="text-danger pt-2">{errors.documentType.message}</div>)}
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="job_number" className="control-label">Select Owners</label>
                                            <Multiselect
                                                options={members}
                                                selectedValues={inputSupportingDocsOwner}
                                                onSelect={(e) => handelChange(e)}
                                                onRemove={(e) => handelChange(e)}
                                                displayValue="name"
                                                {...register('supportingDocsOwner')}
                                                showArrow={true}
                                                disable={isOwnerApproverDisable}
                                            />
                                            {errors.supportingDocsOwner && (
                                                <div className="text-danger pt-2">{errors.supportingDocsOwner.message}</div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="job_number" className="control-label">Select Approvers
                                            </label>
                                            <Multiselect options={members} selectedValues={inputSupportingDocsApprover} onSelect={(e) => handelChangeApprover(e)} onRemove={(e) => handelChangeApprover(e)} displayValue="name" {...register('supportingDocsApprover')} showArrow={true} disable={isOwnerApproverDisable} />
                                            {errors.supportingDocsApprover && (
                                                <div className="text-danger pt-2">{errors.supportingDocsApprover.message}</div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='row px-2 pb-3 clearfix'>
                    <div className='col-md-12 col-lg-12 col-sm-12  text-center'>
                        {isCurrentOwner ? <button className='btn mx-2 custom-btn-outline-info' disabled={(isOwner && isApproved) ? true : false} type='submit'>Update</button> : null}
                        {isApprover ? <button onClick={() => handelObjectivesApproved()} className='btn btn-outline-info mx-2' disabled={isApproved ? true : false} type='button'>Approved</button> : null}
                        {isApprover ? <button onClick={() => handleReasonShow()} className='btn btn-outline-danger mx-2' disabled={isApproved || isRejected ? true : false} type='button'>Reject</button> : null}
                        {isOwner && isApproved ? <button onClick={() => handelRequestToEdit()} className='btn button mx-2' disabled={isApproved === false ? true : false} type='button'>Request To Edit</button> : null}
                    </div>
                </div>
            </form>
            
            <UpdateModal
                open={editFileModal}
                close={handleEditModalClose}
                data={selectedFileData}
                onLoad={members}
                deleteData={false}
            />

            <div className="card card-radius">
                <div className="header card-header custum-bg-warning rounded">
                    <h2 className="text-white">Documents</h2>
                </div>
                <div className="body text-center card-body-shadow">
                    <div className="">
                        <DataTablesSupportingDocs isApproved={isApproved} isOwner={isOwner} ref={childRef} data={selectedFiles} openModal={selectedData} openDeleteModal={deleteTimelineModalShow} mode='edit' />
                    </div>
                </div>
            </div>

            <DisapproveModal
                open={showRejectModal}
                close={handleAddReasonClose}
                data={selectedRowData}
                component={'SupportingDocs'}
                component_id={inputDocumentId}
            />
            <Modal show={deleteSupportingDocsModal} onHide={deleteSupportingDocsModalClose} className="modal fade modal-bx-info" id="exampleModalLong" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
                <div className="modal-dialog  m-0" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title text-danger">Delete Document From Server</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={deleteSupportingDocsModalClose}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            Are you sure to delete?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn button" data-dismiss="modal" onClick={handleDeleteSupportingDocsSubmit}>Confirm</button>
                            <button type="button" className="btn btn-danger py-2 px-3 rounded-lg" data-dismiss="modal" onClick={deleteSupportingDocsModalClose}>Close</button>
                        </div>
                    </div>
                </div>
            </Modal>

                {rejectedReasonVisible ?
                    <>
                        <div className='row px-2 pb-3 clearfix'>
                            <h5>Rejected Reasons</h5>
                            <div className='col-md-12 col-lg-12 col-sm-12'>
                                {rejectedReasonData && rejectedReasonData.map((reason, index) => (
                                    <p key={index}>{reason.rejection_reason} : <span>{moment(reason.rejection_date).format('DD-MM-YYYY hh:mm')}</span></p>
                                ))}
                            </div>
                        </div>
                    </> 
                : null}
        </>
    );
};
export default SupportingDocs;